import { render } from "./AddProject.vue?vue&type=template&id=d9ae50d4&scoped=true&ts=true"
import script from "./AddProject.vue?vue&type=script&lang=ts"
export * from "./AddProject.vue?vue&type=script&lang=ts"

import "./AddProject.vue?vue&type=style&index=0&id=d9ae50d4&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9ae50d4"]])

export default __exports__